<div class="modal-wrapper">
  <button [mat-dialog-close]="false" class="close" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>

  <div class="swiper-place">
    <div #swiper class="swiper">
      <div class="swiper-wrapper">

        <div class="swiper-slide" *ngIf="imageVideoDialogData.video">
          <video controls>
            <source [src]="imageVideoDialogData.video">
          </video>
        </div>

        <div class="swiper-slide" *ngFor="let image of imageVideoDialogData.images">
          <img [src]="image.FileUrl" alt="slide-image">
        </div>
      </div>
    </div>

    <div #prevBtn class="swiper-button-prev"></div>
    <div #nextBtn class="swiper-button-next"></div>
  </div>
</div>
